/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/close'
export default icon
